var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23 12V6.375L16.417 0H1.437C.641 0 0 .627 0 1.406v27.188C0 29.373.64 30 1.438 30H11M5.5 8L16.5 8M5.5 12L16.5 12M5.5 16L11.5 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 24.5,
    r: 8.5,
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    fillRule: "nonzero",
    d: "M22.4 29.127c.749 0 1.369-.125 1.86-.375v-1.625c-.56.242-1.14.362-1.746.362-1.143 0-1.822-.514-2.038-1.542h2.146v-1.13h-2.254l-.012-.21v-.298l.012-.222h2.654V22.97h-2.558c.097-.567.313-1 .647-1.298.334-.299.76-.448 1.276-.448.275 0 .54.037.793.111.254.074.527.177.82.308l.621-1.473c-.694-.347-1.438-.52-2.234-.52-1.028 0-1.885.297-2.57.892-.686.594-1.107 1.404-1.264 2.428h-.844v1.117h.736l-.013.336c0 .165.009.297.026.394h-.75v1.13h.87c.174.994.595 1.773 1.264 2.336.668.563 1.52.844 2.558.844z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceOff);
export default __webpack_public_path__ + "static/media/invoiceOff.e1033ecf8ff5517fff24c71ab5ce7aa9.svg";
export { ForwardRef as ReactComponent };